import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'togglePipe'})
export class TogglePipe implements PipeTransform {

  transform(item: boolean, valid: string, nonValid: string) {
    if (item) {
      return valid;
    } else {
      return nonValid;
    }
  }


}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/common/utils/filter/toggle.pipe.ts